import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { HoldingClass } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useHoldingClassListPage } from '../context/HoldingClassListPageContext';
import HoldingClassTableRow from './HoldingClassTableRow';

const HoldingClassTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useHoldingClassListPage();

  const hasData = data.holdingClasses?.length > 0;

  const rows = data.holdingClasses!.map(
    (holdingClass: HoldingClass, index: number) => (
      <HoldingClassTableRow
        key={holdingClass._id ?? `holdingClass-row-${index}`}
        index={index}
        holdingClass={holdingClass}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoHoldingClassesMessage')}
    />
  );
};

export default HoldingClassTableBody;
